<template>
  <div v-if="model !== null" class="text-center">
    <v-btn
      @click="clicked()"
      :small="width450()"
      :text="width450()"
      :rounded="!width450()"
      :outlined="!width450()"
      :disabled="disabled"
      color="primary"
    >
      <v-icon dense>star</v-icon>
      <span> Avaliar </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    disabled: false,
    model: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    clicked() {
      this.$emit("onClick");
    },
    width450() {
      return this.$vuetify.breakpoint.width < 415;
    },
  },
};
</script>
